import axios from 'axios'
import {config} from '../config'
export const getStories = () =>{
    return axios.get(config.stories)
    .then(function (response) {
        return response
    })
    .catch(function (error) {
      console.log(error);
    })
}

